const initialState = {};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {
  // -------------------------------------------------------
  switch (action.type) {
    case "SET_CRITERIA_DATA":
      return { ...state, criteria: action.criteria };

    default:
      return state;
  }
};

export default reducer;
